import { configureStore } from '@reduxjs/toolkit'
import projectReducer from './projectSlice'
import appReducer from './appSlice'

export const store = configureStore({
  reducer: {
      project: projectReducer,
      app: appReducer
  }
})